// src/components/common/Footer/Footer.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSettingsData } from '../../../actions/subscriptionAction';
import { getPageLists } from '../../../actions/cartAction';
import './Footer.scss';
import logo from '../../../images/new-design/site-logo.png';
import WOW from '../../../js/wow';
import routes from '../../../routes';

const Footer = (props) => {
   const [email, setEmail] = useState('');
   const settingsData = useSelector((state) => state.subscriptionData.settingData);
   const footerPageLists = useSelector((state) => state.cartData.footerPageLists);

   const dispatch = useDispatch();

   let pathname = props.location.pathname;
   const routeAccess = routes.find((i) => i.path === pathname && i.private);

   useEffect(() => {
      new WOW().init();
      dispatch(getSettingsData());
      dispatch(getPageLists());
   }, [dispatch]);

   const handleNewsletterSubmit = (e) => {
      e.preventDefault();
      // Add your newsletter subscription logic here
      setEmail('');
   };

   const go_to_pages = (e, url) => {
      e.preventDefault();
      window.scrollTo(0, 0);
      url === '/subscription-list' && sessionStorage.setItem('activeClass', 1);
      url === '/features' && sessionStorage.setItem('activeClass', 2);
      url === '/' && sessionStorage.setItem('activeClass', 4);
      url === '/contact-us' && sessionStorage.setItem('activeClass', 3);
      if (url === '/blog') {
         window.location.href = 'https://www.caredaily.co.uk/blog';
      } else {
         props.history.push(url);
      }
   };

   let footerText = '';
   if (settingsData && settingsData.footer_text && settingsData.footer_text !== undefined) {
      let textArr = String(settingsData.footer_text).split(',');
      let firstIndex = textArr[0].substring(0, textArr[0].length - 4);
      let dynamicYear = new Date().getFullYear();
      textArr.shift();
      footerText = firstIndex + dynamicYear + textArr;
   }

   const productLinks = [
      { title: 'Features', path: '/features', badge: 'New' },
      { title: 'Pricing', path: '/pricing' },
      { title: 'Case Studies', path: '/case-studies' },
      { title: 'Security', path: '/security' },
      { title: 'Updates', path: '/updates' },
      { title: 'Roadmap', path: '/roadmap' },
   ];

   const exploreLinks = [
      // { title: 'Policies & Procedures', path: '/policies-procedures' },
      // { title: 'Document Library', path: '/documentlibrary' },
      // { title: 'System Features', path: '/features' },
      { title: 'About Us', path: '/about-us' },
      { title: 'Partners', path: '/partners' },
      { title: 'Contact Us', path: '/contact-us' },
   ];

   const resourceLinks = [
      { title: 'Help Centre', path: '/help-centre' },
      { title: 'Documentation', path: '/documentation' },
      { title: 'Blog', path: '/blog' },
      // { title: 'Community', path: '/community' },
      // { title: 'Webinars', path: '/webinars' },
   ];

   const trustBadges = [
      {
         text: 'GDPR Compliant',
         icon: (
            <svg viewBox="0 0 24 24">
               <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
            </svg>
         ),
      },

      {
         text: '256-bit SSL Secured',
         icon: (
            <svg viewBox="0 0 24 24">
               <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z" />
            </svg>
         ),
      },
   ];

   const excludedPaths = [
      '/documents',
      '/dashboard',
      '/users',
      '/course',
      '/groups',
      '/subscriptions',
      '/users/add',
      '/users/edit',
      '/users/activity',
      '/saved-documents',
      '/create-new-documents',
      '/users/deleted-list',
      '/documents/compare',
      '/documents/editor',
      '/index',
      '/documents/recent-updates',
      '/documents/need-review',
      '/documents/uptodate',
      '/subscription/pay',
      '/settings',
      '/document/management/renewal',
      '/invoice',
      '/history',
      '/groups',
      '/group/add',
      '/group/edit',
      '/group/view',
      '/policies',
      '/policies/edit',
      '/policies/create',
      '/policies/multi/create',
      '/users/view',
      '/employees',
      '/employee/add',
      '/employee/edit',
      '/employee/view',
      '/deleted/employees',
      '/employee/login',
      '/employee/register',
      '/forgotpassword',
      '/verifyotp',
      '/resetpassword',
      '/myfiles',
      '/myfiles/editor',
      '/myfiles/details',
      '/policy/documents',
      '/policy/document/view',
      '/publishedpolicies',
      '/deleted-documents',
      '/documents/sign/',
      '/myDocuments',
      '/myDocuments/editor',
      '/myDocuments/details',
      '/formslist',
      '/formbuilder',
      '/webform',
   ];

   const currentYear = new Date().getFullYear();

   if (
      !props.location.pathname.startsWith('/reference/') &&
      !props.location.pathname.startsWith('/document/sign') &&
      !props.location.pathname.startsWith('/webform/fill') &&
      !props.location.pathname.startsWith('/webform/completed') &&
      !props.location.pathname.startsWith('/view/Document') &&
      !excludedPaths.includes(props.location.pathname) &&
      !routeAccess?.hasHeader
   ) {
      return (
         <footer className="footer">
            {/* Newsletter Section */}
            {/* <section className="footer-newsletter">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h3>Stay Updated with Care Daily</h3>
              <p>Get the latest updates on care management best practices and platform features</p>
            </div>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                className="newsletter-input"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="newsletter-btn">Subscribe</button>
            </form>
          </div>
        </section> */}

            {/* Main Footer Content */}
            <div className="footer-main">
               <div className="footer-container">
                  {/* Footer Grid */}
                  <div className="footer-grid">
                     {/* Brand Column */}
                     <div className="footer-brand">
                        <div className="footer-logo">
                           <img src={(settingsData && settingsData.admin_logo) ? settingsData.admin_logo : logo} alt="logo" />
                        </div>
                        <p className="brand-description">
                           Empowering care providers with intelligent documentation and workflow management solutions for better outcomes.
                        </p>
                        <ul className="contact-info">
                           <li>
                              {/* <span>
                      <img src={mob} alt="phone" />
                    </span>
                    <div>
                      {settingsData?.phone
                        ? settingsData.phone.slice(0, 4) + ' ' + settingsData.phone.slice(4, 7) + ' ' + settingsData.phone.slice(7)
                        : '0330 808 0050'}
                    </div>
                  </li>
                  <li>
                    <span>
                      <img src={mail} alt="email" />
                    </span>
                    <div>{settingsData?.email_address ? settingsData.email_address : 'info@company.com'}</div>
                  </li>
                  <li>
                    <span>
                      <img src={loc} alt="location" />
                    </span>
                    <a href={'http://maps.google.com/maps?q=' + settingsData?.address}>
                      {settingsData?.address || 'Company Address'}
                    </a> */}

                              {/* Social & Apps Column */}
                              <div className="footer-column footer-social-column">
                                 {/* <h4>FOLLOW</h4> */}
                                 <div className="social-links">
                                    <a
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       href={settingsData?.facebook_link || '/'}
                                       className="social-link"
                                       aria-label="Facebook"
                                    >
                                       <svg viewBox="0 0 24 24">
                                          <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                                       </svg>
                                    </a>
                                    <a
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       href={settingsData?.twitter_link || '/'}
                                       className="social-link"
                                       aria-label="Twitter"
                                    >
                                       <svg viewBox="0 0 24 24">
                                          <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                                       </svg>
                                    </a>
                                    <a
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       href={settingsData?.instagram_link || '/'}
                                       className="social-link"
                                       aria-label="Instagram"
                                    >
                                       <svg viewBox="0 0 24 24">
                                          <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.4 19.62C5.12 20 12 20 12 20s6.88 0 8.6-.38a2.78 2.78 0 001.94-2A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02v-6.04L15.5 12l-5.75 3.02z" />
                                       </svg>
                                    </a>
                                    <a
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       href={settingsData?.pinterest_link || '/'}
                                       className="social-link"
                                       aria-label="LinkedIn"
                                    >
                                       <svg viewBox="0 0 24 24">
                                          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                       </svg>
                                    </a>
                                 </div>

                                 {/* <h4 className="app-title">EMPLOYEE APP</h4>
                      <div className="app-links">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://apps.apple.com/us/app/cloudoc/id6504866507"
                          className="app-link"
                          aria-label="Download on App Store"
                        >
                          <img src={apple} alt="App Store" />
                        </a>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://play.google.com/store/apps/details?id=com.cloudoc"
                          className="app-link"
                          aria-label="Get it on Google Play"
                        >
                          <img src={play} alt="Google Play" />
                        </a>
                      </div> */}
                              </div>
                           </li>
                        </ul>
                     </div>

                     {/* Product Column */}
                     <div className="footer-column">
                        <h4>PRODUCT</h4>
                        <ul className="footer-links">
                           {productLinks.map((link, index) => (
                              <li key={index}>
                                 <div className="footer-link" onClick={(e) => go_to_pages(e, link.path)}>
                                    {link.title}
                                 </div>
                              </li>
                           ))}
                        </ul>
                     </div>

                     {/* Explore Column */}
                     <div className="footer-column">
                        <h4>COMPANY</h4>
                        <ul className="footer-links">
                           {exploreLinks.map((link, index) => (
                              <li key={index}>
                                 <div className="footer-link" onClick={(e) => go_to_pages(e, link.path)}>
                                    {link.title}
                                 </div>
                              </li>
                           ))}
                        </ul>
                     </div>

                     {/* Resources Column */}
                     <div className="footer-column">
                        <h4>RESOURCES</h4>
                        <ul className="footer-links">
                           {resourceLinks.map((link, index) => (
                              <li key={index}>
                                 <div className="footer-link" onClick={(e) => go_to_pages(e, link.path)}>
                                    {link.title}
                                 </div>
                              </li>
                           ))}
                        </ul>
                     </div>

                     {/* Legal Column */}
                     <div className="footer-column">
                        <h4>LEGAL</h4>
                        <ul className="footer-links">
                           {footerPageLists.length > 0 &&
                              footerPageLists.map((item, i) => (
                                 <li key={i}>
                                    <Link
                                       to={{ pathname: `/pages/${item.slug}` }}
                                       className="footer-link"
                                       onClick={() => sessionStorage.removeItem('activeClass')}
                                    >
                                       {item.name}
                                    </Link>
                                 </li>
                              ))}
                        </ul>
                     </div>

                     {/* Social & Apps Column */}
                     {/* <div className="footer-column footer-social-column">
                <h4>FOLLOW</h4>
                <div className="social-links">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={settingsData?.facebook_link || '/'}
                    className="social-link"
                    aria-label="Facebook"
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={settingsData?.twitter_link || '/'}
                    className="social-link"
                    aria-label="Twitter"
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={settingsData?.instagram_link || '/'}
                    className="social-link"
                    aria-label="Instagram"
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.4 19.62C5.12 20 12 20 12 20s6.88 0 8.6-.38a2.78 2.78 0 001.94-2A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02v-6.04L15.5 12l-5.75 3.02z" />
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={settingsData?.pinterest_link || '/'}
                    className="social-link"
                    aria-label="LinkedIn"
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                  </a>
                </div>

                <h4 className="app-title">EMPLOYEE APP</h4>
                <div className="app-links">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://apps.apple.com/us/app/cloudoc/id6504866507"
                    className="app-link"
                    aria-label="Download on App Store"
                  >
                    <img src={apple} alt="App Store" />
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.cloudoc"
                    className="app-link"
                    aria-label="Get it on Google Play"
                  >
                    <img src={play} alt="Google Play" />
                  </a>
                </div>
              </div> */}
                  </div>

                  {/* Trust Badges */}
                  <div className="trust-badges">
                     {trustBadges.map((badge, index) => (
                        <div key={index} className="trust-badge">
                           {badge.icon}
                           <span>{badge.text}</span>
                        </div>
                     ))}
                  </div>

                  {/* Footer Bottom */}
                  <div className="care-footer-bottom">
                     <div className="footer-copyright">
                        {settingsData &&
                           settingsData !== undefined &&
                           settingsData.footer_text &&
                           settingsData.footer_text !== undefined &&
                           settingsData.footer_text !== null
                           ? footerText
                           : `© ${currentYear} All rights reserved.`}
                     </div>
                     <div className="footer-bottom-links">
                        <Link to="/sitemap" className="footer-bottom-link">
                           Sitemap
                        </Link>
                        <Link to="/accessibility" className="footer-bottom-link">
                           Accessibility
                        </Link>
                        <Link to="/status" className="footer-bottom-link">
                           Status
                        </Link>
                        <Link to="/cookie-settings" className="footer-bottom-link">
                           Cookie Settings
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </footer>
      );
   } else {
      return null;
   }
};

export default Footer;
